import Typography from '@mui/material/Typography';

type FieldHelperProps = {
  text: string;
};

export default function FieldHelper({ text }: FieldHelperProps) {
  return (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
        display: 'block',
        mt: 0.5,
        mb: 0.5,
      }}
    >
      {text}
    </Typography>
  );
}
